// 뉴스레터를 Word(.doc) / PDF 파일로 내보내는 유틸리티.
//
// - Word: 외부 라이브러리 없이 Word 호환 HTML 문서를 만들어 Blob 으로 저장합니다.
//         (텍스트·표가 그대로 살아있어 Word 에서 편집 가능)
// - PDF : index.html 에서 CDN 으로 불러온 html2canvas + jsPDF 전역을 사용해
//         미리보기 DOM 을 그대로 캡처합니다. (한글이 이미지로 렌더되어 폰트 문제 없음)

// ---------- 공통 헬퍼 ----------

// HTML 특수문자 이스케이프 (사용자가 입력한 일반 텍스트용)
function escapeHtml(value) {
  if (value === undefined || value === null) {
    return "";
  }
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

// 날짜 문자열을 사람이 읽기 좋은 형태로
function formatDate(date) {
  if (!date) {
    return "";
  }
  var parsed = Date.parse(date);
  if (isNaN(parsed)) {
    return String(date);
  }
  return new Date(parsed).toUTCString().split("00:00")[0];
}

// 파일명에 쓸 수 없는 문자 정리
function safeFileName(name) {
  return String(name || "newsletter").replace(/[\\/:*?"<>|]/g, "-");
}

// pageNames 를 배열 형태로 정규화 (배열 또는 {page1,page2,page3} 객체 모두 지원)
function normalizePageNames(pageNames) {
  if (Array.isArray(pageNames)) {
    return pageNames;
  }
  if (pageNames && typeof pageNames === "object") {
    return [pageNames.page1, pageNames.page2, pageNames.page3];
  }
  return ["", "", ""];
}

// 이미지를 dataURL 로 변환 (Firebase 이미지의 CORS/캐시 문제로 PDF 에 안 나오는 것 방지)
// 캐시된(크로스오리진 헤더 없는) 이미지가 캔버스를 오염시키지 않도록 캐시를 우회하고
// crossOrigin='anonymous' 로 새로 불러온다. 실패 시 null 반환 → 원본 src 유지.
function loadImageAsDataURL(url) {
  return new Promise(function(resolve) {
    if (!url) {
      resolve(null);
      return;
    }
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function() {
      try {
        var canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      } catch (e) {
        resolve(null);
      }
    };
    img.onerror = function() {
      resolve(null);
    };
    var sep = url.indexOf("?") >= 0 ? "&" : "?";
    img.src = url + sep + "h2c=" + new Date().getTime();
  });
}

function downloadBlob(blob, filename) {
  var url = window.URL.createObjectURL(blob);
  var link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

// ---------- 내보낼 본문 HTML 생성 ----------

function buildBodyHtml(magazine, pageNames, date, noOfWeeks) {
  var page1 = magazine.page1 || {};
  var page2 = magazine.page2 || [];
  var page3 = magazine.page3 || {};
  var names = normalizePageNames(pageNames);
  var tableArray = page1.tableArray || [];

  var dateLine = formatDate(date);
  if (noOfWeeks) {
    dateLine += " · " + noOfWeeks + "주차";
  }

  var html = "";

  // 문서 제목
  html +=
    '<h1 style="font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;color:#222;">뉴스레터</h1>';
  if (dateLine) {
    html +=
      '<p style="color:#777;font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;">' +
      escapeHtml(dateLine) +
      "</p>";
  }

  // ----- 페이지 1 -----
  html += sectionTitle("1", names[0] || "페이지 1");
  if (page1.image) {
    // Word 는 CSS max-width 를 무시하므로 width 속성으로 크기를 고정한다 (A4 본문 폭 안에 들어오도록)
    html +=
      '<p><img src="' +
      escapeHtml(page1.image) +
      '" width="450" style="width:450px;max-width:100%;height:auto;display:block;" /></p>';
  }
  if (page1.imageText) {
    html += '<p style="font-size:15px;">' + escapeHtml(page1.imageText) + "</p>";
  }
  tableArray.forEach(function(table) {
    html += '<table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;width:100%;margin:10px 0;font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;">';
    html +=
      '<tr style="background:#f1f6f9;"><th colspan="2" style="text-align:left;">' +
      escapeHtml(table.header) +
      "</th></tr>";
    (table.rows || []).forEach(function(row) {
      html +=
        '<tr><td style="width:30%;vertical-align:top;">' +
        escapeHtml(row.column1) +
        '</td><td style="width:70%;vertical-align:top;">' +
        escapeHtml(row.column2) +
        "</td></tr>";
    });
    html += "</table>";
  });

  // ----- 페이지 2 -----
  html += sectionTitle("2", names[1] || "페이지 2");
  page2.forEach(function(section) {
    html += '<table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;width:100%;margin:10px 0;font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;">';
    html +=
      '<tr style="background:#f1f6f9;"><th style="text-align:left;">' +
      escapeHtml(section.header) +
      "</th></tr>";
    html +=
      '<tr><td style="white-space:pre-wrap;">' +
      escapeHtml(section.text) +
      "</td></tr>";
    html += "</table>";
  });

  // ----- 페이지 3 (서식 있는 HTML 은 그대로 삽입) -----
  html += sectionTitle("3", names[2] || "페이지 3");
  html += '<table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;width:100%;margin:10px 0;font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;">';
  html +=
    '<tr style="background:#f1f6f9;"><th style="text-align:left;">' +
    escapeHtml(page3.header) +
    "</th></tr>";
  html += '<tr><td>' + (page3.text || "") + "</td></tr>";
  html += "</table>";

  return html;
}

function sectionTitle(num, title) {
  return (
    '<h2 style="font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;color:#222;border-bottom:2px solid #51cbce;padding-bottom:4px;margin-top:24px;">' +
    "[" +
    num +
    "] " +
    escapeHtml(title) +
    "</h2>"
  );
}

// ---------- Word(.doc) 내보내기 ----------

export function exportNewsletterToWord(magazine, pageNames, date, noOfWeeks) {
  var body = buildBodyHtml(magazine, pageNames, date, noOfWeeks);

  // Word 호환 HTML 래퍼 + UTF-8 BOM (한글 깨짐 방지)
  var html =
    "﻿" +
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'><title>뉴스레터</title></head>" +
    "<body style='font-family:Malgun Gothic,Apple SD Gothic Neo,sans-serif;'>" +
    body +
    "</body></html>";

  var blob = new Blob([html], { type: "application/msword;charset=utf-8" });

  var filename =
    safeFileName(
      "newsletter_" +
        (formatDate(date) || "") +
        (noOfWeeks ? "_" + noOfWeeks + "주차" : "")
    ) + ".doc";

  downloadBlob(blob, filename);
}

// ---------- PDF 내보내기 ----------

export async function exportNewsletterToPdf(node, date, noOfWeeks) {
  if (!node) {
    alert("내보낼 내용을 찾을 수 없습니다.");
    return;
  }
  if (!window.html2canvas || !window.jspdf) {
    alert(
      "PDF 라이브러리를 불러오지 못했습니다. 인터넷 연결을 확인한 뒤 다시 시도해 주세요."
    );
    return;
  }

  var html2canvas = window.html2canvas;
  var jsPDF = window.jspdf.jsPDF;

  // 캡처 전에 모든 이미지를 dataURL 로 변환해 둔다 (원본 src 기준으로 매핑)
  var imgEls = Array.prototype.slice.call(node.querySelectorAll("img"));
  var dataUrlMap = {};
  await Promise.all(
    imgEls.map(function(im) {
      var originalSrc = im.src;
      return loadImageAsDataURL(originalSrc).then(function(dataUrl) {
        if (dataUrl) {
          dataUrlMap[originalSrc] = dataUrl;
        }
      });
    })
  );

  var canvas = await html2canvas(node, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
    imageTimeout: 0,
    // html2canvas 가 복제본을 렌더하기 직전에, 이미지 src 를 미리 만든 dataURL 로 교체
    onclone: function(clonedDoc) {
      var clonedImgs = clonedDoc.querySelectorAll("img");
      for (var i = 0; i < clonedImgs.length; i++) {
        var src = clonedImgs[i].src;
        if (dataUrlMap[src]) {
          clonedImgs[i].setAttribute("src", dataUrlMap[src]);
        }
      }
    }
  });

  var imgData = canvas.toDataURL("image/jpeg", 0.95);
  var pdf = new jsPDF("p", "mm", "a4");

  var pageWidth = pdf.internal.pageSize.getWidth();
  var pageHeight = pdf.internal.pageSize.getHeight();

  var imgWidth = pageWidth;
  var imgHeight = (canvas.height * imgWidth) / canvas.width;

  var heightLeft = imgHeight;
  var position = 0;

  pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  // 내용이 한 페이지를 넘으면 페이지를 추가하며 이어 붙임
  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  var filename =
    safeFileName(
      "newsletter_" +
        (formatDate(date) || "") +
        (noOfWeeks ? "_" + noOfWeeks + "주차" : "")
    ) + ".pdf";

  pdf.save(filename);
}
